import { CAPTIONS_ACTION_TYPES } from '../actions/action_types';

const reducer = (state = '', action) => {
  switch (action.type) {
    case CAPTIONS_ACTION_TYPES.SET_VOICE_CAPTIONS:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
